import React, { createContext } from "react";

export const AuthUserContext = createContext();

const AuthState = ({ children, referralCode }) => {  // ✅ Receive referralCode as a prop


  return (
    <AuthUserContext.Provider value={{
      referralCode, // ✅ Now globally accessible
    }}>
      {children}
    </AuthUserContext.Provider>
  );
};

export default AuthState;
